import "./KanaMap.css";

import { AdvancedMarker, Map } from "@vis.gl/react-google-maps";

import { MapMarkerSVG } from "../../../../assets";
import { MapProjectCoordinates } from "../../../../models/shared/mapProjectCoordinates";
import { GenericTooltip } from "../../../forms";
import { MapConstants } from "../constants";
import { useKanaMap } from "./useKanaMap";

interface KanaMapProps {
  coordinates: MapProjectCoordinates[];
  fullWidth: boolean;
  mode: "terrain" | "satellite" | "hybrid" | "roadmap";
  height: number;
}

export const KanaMap = ({ coordinates, fullWidth, mode, height }: KanaMapProps): JSX.Element => {
  const { coordinatesList, center } = useKanaMap(coordinates, fullWidth);

  return (
    <Map
      mapId="58aaea6d244cb261"
      minZoom={MapConstants.MIN_ZOOM_LEVEL}
      maxZoom={MapConstants.MAX_ZOOM_LEVEL}
      defaultZoom={MapConstants.DEFAULT_ZOOM_LEVEL}
      fullscreenControl={false}
      streetViewControl={false}
      zoomControlOptions={{ position: MapConstants.ZOOM_CONTROL_POSITION }}
      defaultCenter={center}
      style={{ height }}
      mapTypeId={mode}
    >
      {coordinatesList.map((coordinate) => (
        <AdvancedMarker
          key={`${coordinate.lat},${coordinate.lng}`}
          position={{
            lat: coordinate.lat,
            lng: coordinate.lng,
          }}
        >
          {coordinate.name ? (
            <GenericTooltip content={<p className="body2 MapTooltip">{coordinate.name}</p>} placement="bottom">
              <MapMarkerSVG />
            </GenericTooltip>
          ) : (
            <MapMarkerSVG />
          )}
        </AdvancedMarker>
      ))}
    </Map>
  );
};
